export const BIO_AND_PHOTO = "bioandphoto";
export const PHOTO = "photo";
export const BIO = "bio";
